import { useQuery } from '@tanstack/react-query';
import { getForecastInspectValue } from 'Services/forecasts';
import { trackError } from 'Utils/errorMonitoring';

export default function useForecastInspectValue(forecastId, filters) {
    const {
        data: forecastValue = {},
        isLoading,
        remove,
    } = useQuery({
        queryKey: ['forecasts', forecastId, 'inspect-value', filters],
        queryFn: () => getForecastInspectValue(forecastId, filters),
        enabled: !!filters?.forecast_value_id,
        onError: (err) => {
            trackError(err);
        },
    });

    return {
        forecastValue,
        isLoading,
        remove,
    };
}
